<!-- <p>emd-header works!</p> -->

<nav class="navbar navbar-expand-lg navbar-light  container-width">
    <!-- module image and name-->
    <!-- <div style="margin: 0px 0px 7px 17px;" class="litle-screen">
        <img [src]="portal_main.accountImageUrl" class="img-circle img-width" style="max-width: 51px;" />
    </div>
    <div style="overflow: hidden;padding: 0px;margin: auto;" class="litle-screen text-center ">
        <div class="module-font font-weight-bold text-white">{{portal_main.accInfo['account_name']}}</div>
        <div class="module-font font-weight-bold text-white">Online Management System</div>
    </div> -->
    <!-- end -->
    <button class="navbar-toggler font-weight-bold text-white b-mar" type="button" data-toggle="collapse"
        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
        aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="litle-screen-bg-color navbar-nav" style="width: 100%;">
            <!--Chief Minister image and name-->
            <!-- <span class="full-screen">&nbsp;&nbsp;</span> -->
            <li class="nav-item form-inline d-fllex bg-primary">
                <div class="n_head">
                    <div>
                        <div class="row">
                            <!-- <div class="col-1"></div> -->
                            <div class="col-6 text-right">

                                <img src="../../../../assets/img/Seal_of_Uttar_Pradesh.svg" class="rounded-circle img-width" alt="Seal of Uttar Pradesh" style="margin-top: 5px;"
                                 />
                                 <img src="../../../../assets/img/nagar_nigam_logo.png" class="rounded-circle img-width" alt="Nagar Nigam Logo" style="margin-top: 5px;"
                                 />

                            </div>
                            <div class="col-6" style="margin-top: 5px;">
                                <div class="row">
                                    <div class="col-12">
                                        <h6>नगर निगम</h6>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 ">
                                        <h6> लखनऊ</h6>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
                <!-- end -->

                <!--Voice Chairman image and name-->
            </li><span class="full-screen">&nbsp;&nbsp;&nbsp;</span>
            <li class="nav-item form-inline">
                <div>
                    <div class="module-font font-weight-bold text-black">PET(s) REGISTRATION PORTAL FOR {{portal_main.accInfo['account_name']}}</div>
                </div>
            </li>
            <!-- Select Language for litile screen -->
            <li class="nav-item text-center form-inline my-2 my-lg-0  litle-screen" style="padding: 0px 5px 0px 0px;">
                <div class="select-language">
                    <ng-select [multiple]="false" placeholder="Select Language" [items]="auth.allLanguage"
                        bindLabel="language_desc" bindValue="language_cd" [selectableGroup]="true"
                        [selectableGroupAsModel]="false" aria-placeholder="Select Language Code" [closeOnSelect]="true"
                        name="language_cd" [(ngModel)]="portal_main.language_cd" (change)="changeLanguage()"
                        style="width:100%">
                    </ng-select>
                </div>
            </li>

            <li class="d-flex litle-screen task-log-mar form-inline">
                <div class="litle-screen">
                    <span class="text-white font-weight-bold">Your Task&nbsp;:-</span>&nbsp;
                    <a class="nav-item nav-link-edit text-dark" [routerLink]="['/task']">{{message_count}}</a>
                </div>
                <br>
                <br>
                <!-- NOTIFICATION FOR LITILE SCREEN -->
                <div class="litle-screen">
                    <span class="text-white font-weight-bold">Notification&nbsp;:-</span>&nbsp;
                    <a class="nav-item nav-link-edit text-dark" [routerLink]="['/notification']">{{noti_count}}</a>
                </div>
                <!-- logout profile for litile screen-->
                <div class="d-flex  form-inline litile-screen ml-auto">
                    <a class="nav-link dropdown-toggle litle-screen link mr-sm-2" data-toggle="dropdown">
                        <img [src]="portal_main.profileImageUrl" class="module-img" />
                        <span class="font-weight-bold text-white">{{erpUser['party_name']}}</span><i
                            class="fa fa-angle-down m-l-5 font-weight-bold text-white"></i></a>
                    <ul class="dropdown-menu dropdown-menu-right ">
                        <a class="dropdown-item " [routerLink]="['/profile']" routerLinkActive="router-link-active"><i
                                class="fa fa-user"></i>Profile</a>
                        <!-- <a [hidden]="hidden" class="dropdown-item" [routerLink]="['/acc']"
                                    routerLinkActive="router-link-active"><i class="fa fa-user-plus"></i>Account</a> -->
                        <a class="dropdown-item" (click)="logOut()" routerLinkActive="router-link-active"><i
                                class="fa fa-power-off"></i>Logout</a>
                    </ul>
                </div>
            </li>
            <!-- module image and name -->
            <li class="nav-item navbar-nav  mx-auto" style="overflow: auto;max-width: 397px;">
                <div class="full-screen font-color d-felx form-inline text-center">
                    <div>
                        <!-- <img [src]="portal_main.accountImageUrl" class="img-circle module-img" style="float:left;" /> -->
                    </div>
                    <div>
                        <div class="module-font font-weight-bold text-black">
                            <!-- {{portal_main.accInfo['account_name']}} -->
                        </div>
                        <!-- <div class="module-font font-weight-bold text-black">Online Management System</div> -->
                    </div>
                </div>
            </li>
            <!--Language-->
            <!-- START TOP-LEFT TOOLBAR-->
            <ul class="nav navbar-toolbar">
            </ul>
            <!-- END TOP-LEFT TOOLBAR-->

            <!-- START TOP-RIGHT TOOLBAR-->
            <ul class="nav navbar-toolbar">
                <li style="color: white; margin-right: 10px;">
                    SELECT Language -:
                </li>
                <li>
                    <ng-select [multiple]="false" placeholder="Select Language" [items]="auth.allLanguage"
                    bindLabel="language_desc" bindValue="language_cd" [selectableGroup]="true"
                    [selectableGroupAsModel]="false" aria-placeholder="Select Language Code" [closeOnSelect]="true"
                    name="language_cd" [(ngModel)]="portal_main.language_cd" (change)="changeLanguage()"
                    style="width:100%">
                </ng-select>
                </li>
                <li class="dropdown dropdown-inbox">
                    <a class="nav-link dropdown-toggle" [routerLink]="['/task']" data-toggle="dropdown"><i
                            class="fa fa-envelope-o" style="font-size: 2.5rem;"></i>
                        <sub class="font-weight-bold"
                            style="margin-left: 5px; color: black;font-size: 1.5rem;">{{portal_main.count}}</sub>
                    </a>

                    <!-- <ul class="dropdown-menu dropdown-menu-right dropdown-menu-media">
                <li class="dropdown-menu-header">
                    <div>
                        <span><strong>{{mainService.count}} New</strong> {{mainService.allLableShowObj[mainService.language_cd+'AC_Header6']}}Messages</span>
                        <a class="pull-right" [routerLink]="['/task']">{{mainService.allLableShowObj[mainService.language_cd+'AC_Header7']}}view all</a>
                    </div>
                </li>
            </ul> -->
                </li>
                <li>
                    <a class="nav-link dropdown-toggle my-2 my-lg-0 text-center form-inline" data-toggle="dropdown" (click)="open_noification()"><i
                        class="fa fa-bell-o font-weight-bold text-black"></i>
                    <SUP class="badge badge-primary  ">{{noti_count}}</SUP>
                </a>
                </li>
                <!-- <li class="dropdown dropdown-notification">
            <a class="nav-link dropdown-toggle" data-toggle="dropdown"><i class="fa fa-bell-o rel"><span
                        class="notify-signal"></span></i></a>
            <ul class="dropdown-menu dropdown-menu-right dropdown-menu-media">
                <li class="dropdown-menu-header">
                    <div>
                        <span><strong>{{mainService.allLableShowObj[mainService.language_cd+'AC_Header5']}}</strong> {{mainService.allLableShowObj[mainService.language_cd+'AC_Header8']}}</span>
                        <a class="pull-right" href="javascript:;">{{mainService.allLableShowObj[mainService.language_cd+'AC_Header7']}}</a>
                    </div>
                </li>

            </ul>
        </li> -->
                <li class="dropdown dropdown-user">
                    <a class="nav-link dropdown-toggle link" data-bs-toggle="dropdown" id="navbarDropdown" role="button" aria-expanded="false">
                        <img [src]="portal_main.profileImageUrl" />
                        <span></span>{{this.erpUser['party_name']}}<i class="fa fa-angle-down m-l-5"></i></a>
                    <ul class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" [routerLink]="['/profile']" routerLinkActive="router-link-active"><i
                                class="fa fa-user"></i> Profile</a>
                        <li class="dropdown-divider"></li>
                        <!-- [routerLink]="['/login']" routerLinkActive="router-link-active" -->
                        <a class="dropdown-item" (click)="logOut()"><i
                                class="fa fa-power-off"></i> Logout</a>
                    </ul>
                </li>
            </ul>
            <!-- END TOP-RIGHT TOOLBAR-->

        </ul>
    </div>
</nav>




